export default "__VITE_ASSET__BwHJelr4__"